import { asyncComponent } from '@datenpate/after';

export default [
  {
    path: '/:slug*',
    component: asyncComponent({
      loader: () => import(/* webpackChunkName: "careers" */ './Page'),
      chunkName: 'careers'
    })
  }
];
